import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-facts' })
export class FactsComponent {

    private dataDuration: any;

	constructor(private element: HTMLElement) {
		this.dataDuration = this.element.getAttribute('data-duration');

        function onVisible(element, callback) {
            new IntersectionObserver((entries, ioOptions) => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        callback(element);
                        ioOptions.disconnect();
                    }
                });
            }).observe(element);
        }

        onVisible(this.element, () => {
            this.onVisible();
        });
	}

	onVisible() {
		const counters = this.element.querySelectorAll('.js-number');

		counters.forEach(count => {
			const endValue = parseInt(count.innerHTML);
			const duration = parseInt(this.dataDuration) * 1000;
			const ticks = parseInt(this.dataDuration) * 50;

			count.innerHTML = "0";
			function countUpLoop(finishedTicks: number) {
				if (finishedTicks <= ticks) {
					setTimeout(() => {
						count.innerHTML = `${Math.ceil(endValue / ticks * finishedTicks).toLocaleString("de-CH")}`;
						countUpLoop(finishedTicks + 1);
					}, duration / ticks);
				}
			}

			countUpLoop(0);
		});
	}
}
